export const UPDATE_PARTICIPATION = 'UPDATE_PARTICIPATION'
export const SET_LOADING = 'SET_LOADING'
export const SET_PENDING = 'SET_PENDING'
export const SET_PARTICIPATION_COMPLETED = 'PARTICIPATION_COMPLETED'
